var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4824 24.8672V39.3949H26.0102L22.9804 36.3652H14.5122V27.897L11.4824 24.8672Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6732 47.4095L46.3254 43.0012V46.9702H3.9087V40.6834H6.93847V38.2596H3.9087V28.1856H6.93847V25.7618H3.9087V16.0666H6.93847V13.6428H3.9087V5.17456L28.0559 29.1855V24.9135L3.46938 0.448126C3.2575 0.234484 2.98678 0.0887812 2.69176 0.0295952C2.39674 -0.0295908 2.09078 0.000421177 1.81289 0.115805C1.53499 0.231189 1.29775 0.426717 1.13141 0.67746C0.965078 0.928203 0.877182 1.2228 0.878932 1.52369V48.4851C0.878932 48.8869 1.03854 49.2722 1.32263 49.5563C1.60673 49.8404 1.99204 50 2.39382 50H49.5976C49.8985 50.0017 50.1931 49.9138 50.4438 49.7475C50.6946 49.5812 50.8901 49.3439 51.0055 49.066C51.1209 48.7881 51.1509 48.4822 51.0917 48.1871C51.0325 47.8921 50.8868 47.6214 50.6732 47.4095Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2055 43.9363H40.2651C41.0686 43.9363 41.8393 43.617 42.4075 43.0489C42.9756 42.4807 43.2949 41.71 43.2949 40.9065V11.6692L39.8106 5.26127C39.5411 4.79441 39.152 4.4079 38.6833 4.14161C38.2147 3.87532 37.6834 3.73888 37.1444 3.74639C36.5932 3.75076 36.0537 3.90542 35.5838 4.19372C35.114 4.48201 34.7318 4.89302 34.4782 5.38246L31.1758 11.6995V40.9065C31.1758 41.71 31.495 42.4807 32.0632 43.0489C32.6314 43.617 33.402 43.9363 34.2055 43.9363ZM34.2055 12.4267L37.1444 6.71556L40.2651 12.4418V34.847H34.2055V12.4267ZM34.2055 37.3162H40.2651V41.0125H34.2055V37.3162Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.9f3d246cddc8ee9f59ed9d58cb21174d.svg";
export { ForwardRef as ReactComponent };